export default "__VITE_ASSET__Botohmzd__"